// Servisin haftanın hangi günleri yapıldığını seçtiren form elemanı.
// 1=Pazartesi ... 7=Pazar. Boş seçim → "hafta içi (varsayılan)" olarak yorumlanır
// (backend geriye dönük uyum). SADECE recurring servislerde (standart personel servisi,
// öğrenci servisi) kullanılır; puantaj ve otomatik sürücü önermesini etkiler, mobil
// görünürlüğü etkilemez.
//
// Diğer form elemanları (Input, CustomSelect) gibi `onInput(id, value, isValid)` ile
// çalışır ve mount olduğunda initialValue'yu kaydeder.

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const WEEKDAYS = [1, 2, 3, 4, 5, 6, 7];
const DEFAULT_WEEKDAYS = [1, 2, 3, 4, 5]; // Pzt–Cum (backend varsayılanıyla aynı)

// initialValue boş/tanımsız → varsayılan hafta içi (Pzt–Cum) ön-seçili gösterilir.
// Böylece ekranda backend varsayılanı görsel olarak yansır. Kaydedilince [1..5] gider;
// bu da backend'de "hafta içi" ile birebir aynı davranışı üretir.
const resolveInitial = (value, defaultDays) => {
  if (Array.isArray(value) && value.length > 0) return [...value].sort((a, b) => a - b);
  return [...defaultDays].sort((a, b) => a - b);
};

const ServiceDaysPicker = ({ id, onInput, initialValue, label, description, defaultDays = DEFAULT_WEEKDAYS }) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState(() => resolveInitial(initialValue, defaultDays));

  // Mount / initialValue değişiminde formState'e kaydet (her zaman geçerli).
  useEffect(() => {
    const initial = resolveInitial(initialValue, defaultDays);
    setSelected(initial);
    onInput(id, initial, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, JSON.stringify(initialValue)]);

  const toggle = (day) => {
    setSelected((prev) => {
      const next = prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day].sort((a, b) => a - b);
      onInput(id, next, true);
      return next;
    });
  };

  const selectedSet = new Set(selected);
  const isDefault = selected.length === 0;

  return (
    <div className="service-days-picker" style={{ marginBottom: "1rem" }}>
      {label && (
        <label style={{ display: "block", fontWeight: 600, marginBottom: 6, color: "#3a3a3a" }}>{label}</label>
      )}
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
        {WEEKDAYS.map((day) => {
          const active = selectedSet.has(day);
          return (
            <button
              key={day}
              type="button"
              aria-pressed={active}
              onClick={() => toggle(day)}
              title={t(`serviceDays.weekday.${day}`)}
              style={{
                minWidth: 42,
                padding: "6px 10px",
                borderRadius: 6,
                border: `1px solid ${active ? "#0d47a1" : "#cfd6dd"}`,
                background: active ? "#1976d2" : "#fff",
                color: active ? "#fff" : "#667",
                fontWeight: 600,
                fontSize: "0.82rem",
                cursor: "pointer",
                transition: "all 0.12s ease",
              }}
            >
              {t(`serviceDays.weekday.${day}`)}
            </button>
          );
        })}
      </div>
      <div style={{ marginTop: 6, fontSize: "0.78rem", color: "#888" }}>
        {isDefault ? t("serviceDays.defaultHint") : description || t("serviceDays.description")}
      </div>
    </div>
  );
};

export default ServiceDaysPicker;
